import { render } from "./ShareholderNotificationSettingsTab.vue?vue&type=template&id=d59628e6&scoped=true&ts=true"
import script from "./ShareholderNotificationSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ShareholderNotificationSettingsTab.vue?vue&type=script&lang=ts"

import "./ShareholderNotificationSettingsTab.vue?vue&type=style&index=0&id=d59628e6&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59628e6"]])

export default __exports__